import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Card, CardHeader, CardBody, CardFooter, CardText, Button } from 'reactstrap'

export default function NoWorkspaces() {
  console.log('NoWorkspaces rendered')

  const [goToLogin, setGoToLogin] = useState(false)

  if (goToLogin) {
    return <Navigate to="/login" />
  }
  return (
    <Card style={{ maxWidth: '500px', margin: '0 auto' }} >
      <CardHeader tag="h4">No Workspaces Assigned</CardHeader>
      <CardBody>
        <CardText>This user account does not have any workspaces assigned.  Please contact the system administrator.</CardText>
      </CardBody>
      <CardFooter style={{ backgroundColor: 'white', textAlign: 'center' }} >
        <Button color="primary" style={{ fontSize: '1.25rem' }} onClick={() => setGoToLogin(true)}>Return to Sign In</Button>
      </CardFooter>
    </Card>
  )
}
